import {FEATURING_BLOCK_ANCHOR_ID} from '@utils/articles/tableOfContents';

import {ArticleFeaturingBlock} from '@strapi/types/Articles';

import ArticleFeaturingCards from '../ArticleFeaturingCards';
import styles from './ArticleFeaturingBlock.module.scss';

type Props = {
  featuring: ArticleFeaturingBlock;
};

export default function ArticleFeaturingBlock({featuring}: Props) {
  return (
    <>
      <h2 id={FEATURING_BLOCK_ANCHOR_ID} className={styles.title}>
        {featuring.title}
      </h2>
      <ArticleFeaturingCards cards={featuring.cards} />
    </>
  );
}
